import { TravelReportRequest, ReportSummary } from 'models/reportSummary';

import { Reset } from './generic';

export const REPORT_SUMMARY_REQUEST = 'REPORT_SUMMARY_REQUEST';
export const REPORT_SUMMARY_SUCCESS = 'REPORT_SUMMARY_SUCCESS';
export const REPORT_SUMMARY_ERROR = 'REPORT_SUMMARY_ERROR';
export const REPORT_SUMMARY_LOADING = 'REPORT_SUMMARY_LOADING';

export interface ReportSummaryRequest {
  type: typeof REPORT_SUMMARY_REQUEST;
  filters?: TravelReportRequest;
}

export interface ReportSummaryData {
  type: typeof REPORT_SUMMARY_SUCCESS;
  reportSummary: ReportSummary;
}

export interface ReportSummaryLoading {
  type: typeof REPORT_SUMMARY_LOADING;
  loading: boolean;
}

export type ReportActions = ReportSummaryRequest | ReportSummaryData | ReportSummaryLoading | Reset;

export const reportSummaryRequest = (filters?: TravelReportRequest): ReportSummaryRequest => ({
  type: REPORT_SUMMARY_REQUEST,
  filters,
});

export const reportSummarySuccess = (reportSummary: ReportSummary): ReportSummaryData => ({
  type: REPORT_SUMMARY_SUCCESS,
  reportSummary,
});

export const reportSummaryError = () => ({ type: REPORT_SUMMARY_ERROR });

export const reportSummaryLoading = (loading: boolean): ReportSummaryLoading => ({
  type: REPORT_SUMMARY_LOADING,
  loading,
});
